// import React, { useEffect, useRef, useMemo, useState } from "react";
// import cleanJobDescription from "../cleanJobDescription";

// import {
//   Alert,
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   Collapse,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Divider,
//   FormControl,
//   Grid,
//   IconButton,
//   InputLabel,
//   MenuItem,
//   Paper,
//   Typography,
//   Select,
//   Snackbar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TextField,
//   Tooltip,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
// import DownloadIcon from "@mui/icons-material/Download";
// import StarIcon from "@mui/icons-material/Star";
// import NoteAddIcon from "@mui/icons-material/NoteAdd";
// import DeleteIcon from "@mui/icons-material/Delete";
// import SmartToyIcon from "@mui/icons-material/SmartToy";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { API_URL } from "../config";

// /**
//  * Calculates the number of days a job/application has been active from startDate to endDate or today.
//  * @param {string|Date} startDate - The start date (ISO string or Date object)
//  * @param {string|Date} [endDate] - Optional end date (ISO string or Date object)
//  * @returns {string|number} Number of days active (inclusive) or "-" if invalid
//  */
// function calculateDaysActive(startDate, endDate) {
//   if (!startDate) return "-";
  
//   try {
//     const start = new Date(startDate);
//     const end = endDate ? new Date(endDate) : new Date();
    
//     if (isNaN(start.getTime()) || isNaN(end.getTime())) return "-";
    
//     start.setHours(0, 0, 0, 0);
//     end.setHours(0, 0, 0, 0);
    
//     if (end < start) return 0;
    
//     const diffMs = end - start;
//     return Math.floor(diffMs / (1000 * 60 * 60 * 24)) + 1;
//   } catch (error) {
//     console.error('Error calculating active days:', error);
//     return "-";
//   }
// }

// function useJobOrderAIEvalStatus(appIds, jobOrderId) {
//   const [aiEvalStatus, setAiEvalStatus] = useState({});

//   const stableAppIds = useMemo(() => {
//     if (!Array.isArray(appIds)) return [];

//     return Array.from(new Set(appIds.filter(Boolean)));
//   }, [appIds]);

//   useEffect(() => {
//     if (!jobOrderId || stableAppIds.length === 0) {
//       setAiEvalStatus({});
//       return;
//     }

//     let cancelled = false;

//     // initialize loading states
//     const initial = {};
//     stableAppIds.forEach((appId) => {
//       initial[appId] = {
//         loading: true,
//         error: null,
//         status: null,
//         match_score: null,
//       };
//     });
//     setAiEvalStatus(initial);

//     const fetcher = window.fetchWithAuth || fetchWithAuth || fetch;

//     Promise.all(
//       stableAppIds.map(async (appId) => {
//         try {
//           const res = await fetcher(
//             `${API_URL}/ai/evaluations/by-application-job/${appId}/${jobOrderId}`
//           );

//           // No evaluation yet – treat as "no evaluation", not an error
//           if (res.status === 404) {
//             return [
//               appId,
//               {
//                 loading: false,
//                 error: null,
//                 status: null,
//                 match_score: null,
//               },
//             ];
//           }

//           if (!res.ok) {
//             const text = await res.text().catch(() => "");
//             throw new Error(text || `Request failed (${res.status})`);
//           }

//           const data = await res.json();
//           const ev = data?.evaluation || null;

//           return [
//             appId,
//             {
//               loading: false,
//               error: null,
//               status: ev?.status ?? null,
//               match_score: ev?.match_score ?? null,
//             },
//           ];
//         } catch (e) {
//           return [
//             appId,
//             {
//               loading: false,
//               error: e?.message || "Unknown error",
//               status: null,
//               match_score: null,
//             },
//           ];
//         }
//       })
//     ).then((entries) => {
//       if (cancelled) return;
//       const next = {};
//       for (const [appId, value] of entries) {
//         next[appId] = value;
//       }
//       setAiEvalStatus(next);
//     });

//     return () => {
//       cancelled = true;
//     };
//   }, [jobOrderId, stableAppIds]);

//   return aiEvalStatus;
// }



// function AIEvalStatusCell({ aiEvalStatus, appId }) {
//   const evalObj = aiEvalStatus[appId];
//   if (!evalObj) return null;
//   if (evalObj.loading) {
//     return <CircularProgress size={18} />;
//   }
//   if (evalObj.error) {
//     return (
//       <Typography color="error" variant="body2">
//         Error
//       </Typography>
//     );
//   }
//   if (evalObj.status) {
//     let chipProps = {
//       label: evalObj.status.charAt(0).toUpperCase() + evalObj.status.slice(1),
//       size: "small",
//       sx: { fontWeight: 600, textTransform: "capitalize" },
//       variant: "outlined",
//     };
//     if (evalObj.status === "completed") {
//       chipProps.sx = { ...chipProps.sx, color: "green", borderColor: "green" };
//     } else if (evalObj.status === "failed") {
//       chipProps.sx = {
//         ...chipProps.sx,
//         color: "#d32f2f",
//         borderColor: "#d32f2f",
//       };
//     } else if (evalObj.status === "processing") {
//       chipProps.sx = {
//         ...chipProps.sx,
//         color: "#FFA500",
//         borderColor: "#FFA500",
//       };
//     } else {
//       chipProps.sx = {
//         ...chipProps.sx,
//         color: "#90A4AE",
//         borderColor: "#90A4AE",
//       };
//     }
//     return <Chip {...chipProps} />;
//   }
//   return (
//     <Chip
//       label="No evaluation"
//       size="small"
//       variant="outlined"
//       sx={{
//         fontWeight: 600,
//         color: "#90A4AE",
//         borderColor: "#90A4AE",
//         textTransform: "capitalize",
//       }}
//     />
//   );
// }

// function getScoreBarColor(score) {
//   if (typeof score !== "number") return "#90A4AE";
//   if (score >= 1 && score <= 2) {
//     return "#FF4C4C"; // Very Poor
//   } else if (score >= 3 && score <= 4) {
//     return "#FF884C"; // Poor
//   } else if (score === 5) {
//     return "#FFD700"; // Average / Neutral
//   } else if (score >= 6 && score <= 7) {
//     return "#A8E05F"; // Good
//   } else if (score >= 8 && score <= 9) {
//     return "#6FCF97"; // Very Good
//   } else if (score === 10) {
//     return "#2ECC71"; // Excellent
//   } else {
//     return "#d32f2f"; // fallback
//   }
// }

// function AIEvalScoreCell({ aiEvalStatus, appId }) {
//   const evalObj = aiEvalStatus[appId];
//   if (!evalObj) return null;
//   if (evalObj.loading) {
//     return <CircularProgress size={18} />;
//   }
//   if (
//     typeof evalObj.match_score === "number" &&
//     isFinite(evalObj.match_score)
//   ) {
//     return (
//       <div style={{ display: "flex", alignItems: "center", minWidth: 80 }}>
//         <div
//           style={{
//             flex: 1,
//             background: "#ECEFF1",
//             height: 12,
//             borderRadius: 7,
//             overflow: "hidden",
//             marginRight: 8,
//             position: "relative",
//           }}
//         >
//           <div
//             style={{
//               width: `${Math.max(0, Math.min(10, evalObj.match_score)) * 10}%`,
//               height: "100%",
//               borderRadius: 7,
//               transition: "width 0.6s cubic-bezier(0.4,0,0.2,1)",
//               background: getScoreBarColor(evalObj.match_score),
//               boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
//             }}
//           />
//         </div>
//         <span
//           style={{
//             fontWeight: 400,
//             minWidth: 24,
//             textAlign: "right",
//             color: getScoreBarColor(evalObj.match_score),
//           }}
//         >
//           {evalObj.match_score}
//         </span>
//       </div>
//     );
//   }
//   return (
//     <Typography variant="body2" sx={{ color: "#90A4AE", fontWeight: 600 }}>
//       NA
//     </Typography>
//   );
// }
// // --- END AI Evaluation Status Logic ---
// // import TablePagination from "@mui/material/TablePagination";
// import { useNavigate, useParams } from "react-router-dom";
// import AdminSidebar from "../AdminSidebar";
// import { useAuth } from "../App";

// function JobOrderDetail() {
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   // --- Reject Confirmation Modal State ---
//   const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
//   const [rejecting, setRejecting] = useState(false);
//   const [rejectError, setRejectError] = useState("");
//   const [rejectApplicant, setRejectApplicant] = useState(null);
  
//   const auth = useAuth();
//   const { fetchWithAuth } = auth || {};
//   const { id } = useParams();
//   const navigate = useNavigate();
//   // Sequential loading states for each section
//   const [jobOrder, setJobOrder] = useState(null);
//   const [job, setJob] = useState(null);

//   // Section loading states
//   const [jobOrderLoading, setJobOrderLoading] = useState(true);
//   const [jobOrderError, setJobOrderError] = useState("");

//   const [questionsLoading, setQuestionsLoading] = useState(false);
//   const [questionsError, setQuestionsError] = useState("");
//   const [questionsLoaded, setQuestionsLoaded] = useState(false);

//   const [candidatesLoading, setCandidatesLoading] = useState(false);
//   const [candidatesError, setCandidatesError] = useState("");
//   const [candidatesLoaded, setCandidatesLoaded] = useState(false);

//   // Legacy loading/error states for backward compatibility
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [expandedRows, setExpandedRows] = useState({});
//   const [activityLogs, setActivityLogs] = useState({});
//   const [activityLogsLoading, setActivityLogsLoading] = useState({});
//   const [activityLogsError, setActivityLogsError] = useState({});
//   const [jobOrderTitles, setJobOrderTitles] = useState({});
//   const [logActivityOpen, setLogActivityOpen] = useState(false);
//   const [logActivityApplicant, setLogActivityApplicant] = useState(null);
//   const [activityType, setActivityType] = useState("note");
//   const [activityNotes, setActivityNotes] = useState("");
//   const [oldStatus, setOldStatus] = useState("");
//   const [newStatus, setNewStatus] = useState("");

//   const [statusOptions, setStatusOptions] = useState([]);
//   const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
//   const [statusOptionsError, setStatusOptionsError] = useState("");

//   const [logLoading, setLogLoading] = useState(false);
//   const [logError, setLogError] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const aiEvalAppIds = useMemo(() => {
//     if (!jobOrder || !Array.isArray(jobOrder.applications)) return [];

//     // apply same filter as your table (search)
//     const filtered = jobOrder.applications
//       .filter((a) => a && a.id)
//       .filter((a) => {
//         if (!searchQuery) return true;
//         const q = searchQuery.toLowerCase();
//         return (
//           (a.applicant_name &&
//             a.applicant_name.toLowerCase().includes(q)) ||
//           (a.applicant_email &&
//             a.applicant_email.toLowerCase().includes(q)) ||
//           (a.status && a.status.toLowerCase().includes(q))
//         );
//       });

//     const start = page * rowsPerPage;
//     const end = start + rowsPerPage;

//     return filtered.slice(start, end).map((a) => a.id);
//   }, [jobOrder, searchQuery, page, rowsPerPage]);

//   const aiEvalStatus = useJobOrderAIEvalStatus(aiEvalAppIds, jobOrder?.id);

//   // --- AI Resume Modal State ---
//   const [aiModalOpen, setAiModalOpen] = useState(false);
//   const [aiModalLoading, setAiModalLoading] = useState(false);
//   const [aiModalError, setAiModalError] = useState("");
//   const [aiModalJson, setAiModalJson] = useState(null);
//   const [aiModalApplicant, setAiModalApplicant] = useState(null);
//   // --- AI Resume Analyze Modal state ---
//   // Loading state for the AI analysis POST request
//   const [analyzeLoading, setAnalyzeLoading] = useState(false);
//   // Error message for the analysis POST
//   const [analyzeError, setAnalyzeError] = useState("");
//   // Result object/string from /ai/analyze-resume-text/
//   const [analyzeResult, setAnalyzeResult] = useState(null);

//   // --- PDF.js for resume extraction (as in PdfTextExtractor.js) ---
//   // Only import once at top of file
//   // import * as pdfjsLib from "pdfjs-dist";
//   // pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

//   async function handleScreenWithAI(applicant) {
//     setAiModalApplicant(applicant);
//     setAiModalOpen(true);
//     setAiModalLoading(true);
//     setAiModalError("");
//     setAiModalJson(null);
//     try {
//       // --- Fetch resume from applicant.resume (preferred) ---
//       let resumeFileUrl = applicant.resume || null;
//       // If resumeFileUrl is a relative path, prepend the backend API URL
//       if (resumeFileUrl && resumeFileUrl.startsWith("/uploads")) {
//         resumeFileUrl = API_URL.replace(/\/$/, "") + resumeFileUrl;
//       }
//       // Fallback: check answers for file-type resume if not present
//       if (!resumeFileUrl) {
//         const answers = applicant.answers || {};
//         for (const key in answers) {
//           const ans = answers[key];
//           if (ans && ans.type === "file" && ans.value && ans.value.url) {
//             resumeFileUrl = ans.value.url;
//             break;
//           }
//         }
//       }
//       if (!resumeFileUrl)
//         throw new Error("No resume file found on applicant record.");
//       // Fetch the resume file (PDF or DOCX)
//       const res = await fetch(resumeFileUrl);
//       if (!res.ok) throw new Error("Failed to fetch resume file.");
//       const arrayBuffer = await res.arrayBuffer();
//       // Detect file type by extension
//       const ext = resumeFileUrl.split(".").pop().toLowerCase();
//       let fullText = "";
//       // If PDF, use pdfjs-dist
//       if (ext === "pdf") {
//         // --- PDF Extraction ---
//         const pdfjsLib = await import("pdfjs-dist/build/pdf");
//         pdfjsLib.GlobalWorkerOptions.workerSrc =
//           "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
//         const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
//         for (let i = 1; i <= pdf.numPages; i++) {
//           const page = await pdf.getPage(i);
//           const content = await page.getTextContent();
//           const pageText = content.items.map((item) => item.str).join(" ");
//           fullText += pageText + "\n";
//         }
//         // If DOCX, load mammoth from /vendor/mammoth.browser.min.js in public
//       } else if (ext === "docx") {
//         // --- DOCX Extraction using mammoth from local public/vendor ---
//         try {
//           // Helper to load mammoth from local /vendor if not already loaded
//           async function loadMammothFromLocal() {
//             if (window.mammoth) return window.mammoth;
//             return new Promise((resolve, reject) => {
//               const script = document.createElement("script");
//               script.src = "/vendor/mammoth.browser.min.js";
//               script.onload = () => resolve(window.mammoth);
//               script.onerror = () =>
//                 reject(
//                   new Error(
//                     "Failed to load mammoth from /vendor/mammoth.browser.min.js"
//                   )
//                 );
//               document.body.appendChild(script);
//             });
//           }
//           // Load mammoth and extract text
//           const mammoth = await loadMammothFromLocal();
//           const { value } = await mammoth.extractRawText({ arrayBuffer });
//           fullText = value;
//         } catch (err) {
//           // Handle extraction errors
//           throw new Error("Failed to extract DOCX text: " + err.message);
//         }
//       } else {
//         // Show error for unsupported file types
//         throw new Error("Unsupported resume file type: " + ext);
//       }
//       // Compose JSON object
//       const rawDescription =
//         (job && job.description) || (jobOrder && jobOrder.description) || "";
//       // Strip all HTML tags for plain text
//       const plainJobDescription = rawDescription
//         .replace(/<[^>]+>/g, " ")
//         .replace(/&nbsp;/gi, " ")
//         .replace(/&amp;/gi, "&")
//         .replace(/&lt;/gi, "<")
//         .replace(/&gt;/gi, ">")
//         .replace(/\s+/g, " ")
//         .trim();
//       // Clean resume text: strip HTML tags, replace &nbsp;, &amp;, etc, collapse whitespace and newlines
//       let plainResumeText = fullText
//         .replace(/<[^>]+>/g, " ") // Remove HTML tags
//         .replace(/&nbsp;/gi, " ")
//         .replace(/&amp;/gi, "&")
//         .replace(/&lt;/gi, "<")
//         .replace(/&gt;/gi, ">")
//         .replace(/[\r\t]+/g, " ") // Remove tabs and carriage returns
//         .replace(/\n{2,}/g, "\n") // Collapse multiple newlines
//         .replace(/\s{2,}/g, " ") // Collapse multiple spaces
//         .trim();
//       const jsonObj = {
//         resume_text: plainResumeText,
//         job_description: plainJobDescription,
//         application_id: applicant.id,
//         job_order_id: jobOrder.id,
//       };
//       setAiModalJson(jsonObj);
//     } catch (e) {
//       setAiModalError(e.message || "Failed to extract resume text.");
//     } finally {
//       setAiModalLoading(false);
//     }
//   }

//   function handleCloseAiModal() {
//     setAiModalOpen(false);
//     setAiModalApplicant(null);
//     setAiModalJson(null);
//     setAiModalError("");
//     setAiModalLoading(false);
//     setAnalyzeLoading(false);
//     setAnalyzeError("");
//     setAnalyzeResult(null);
//   }

//   const handleToggleExpand = (id) => {
//     setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
//   };

//   const handleOpenLogActivity = async (applicant) => {
//     setLogActivityApplicant(applicant);
//     setActivityType("note");
//     setActivityNotes("");
//     setOldStatus(applicant.status || "");
//     setNewStatus("");
//     setLogError("");
//     setStatusOptions([]);
//     setStatusOptionsLoading(false);
//     setStatusOptionsError("");
//     setLogActivityOpen(true);
//     // Pre-fetch status options if applicant and activityType is "status_change" by default
//     // (If user switches to status_change, also fetch in modal below)
//   };

//   // Fetch statuses when activityType changes to status_change and modal is open
//   useEffect(() => {
//     async function fetchStatusOptions() {
//       setStatusOptionsLoading(true);
//       setStatusOptionsError("");
//       try {
//         const fetcher = window.fetchWithAuth || fetchWithAuth;
//         if (!fetcher) throw new Error("fetchWithAuth is not available");
//         const res = await fetcher(`${API_URL}/statuses/`);
//         if (!res.ok) throw new Error("Failed to fetch statuses");
//         const data = await res.json();
//         setStatusOptions(Array.isArray(data) ? data : data.statuses || []);
//       } catch (e) {
//         setStatusOptionsError(e.message || "Failed to fetch statuses");
//       } finally {
//         setStatusOptionsLoading(false);
//       }
//     }
//     if (
//       logActivityOpen &&
//       activityType === "status_change" &&
//       statusOptions.length === 0 &&
//       !statusOptionsLoading
//     ) {
//       fetchStatusOptions();
//     }
//   }, [logActivityOpen, activityType]);
//   const handleCloseLogActivity = () => {
//     setLogActivityOpen(false);
//     setLogActivityApplicant(null);
//     setActivityType("note");
//     setActivityNotes("");
//     setOldStatus("");
//     setNewStatus("");
//     setLogError("");
//   };

//   async function handleSubmitLogActivity() {
//     if (!logActivityApplicant || !logActivityApplicant.id) return;
//     setLogLoading(true);
//     setLogError("");
//     try {
//       // 1. Log the activity
//       if (!fetchWithAuth) throw new Error("fetchWithAuth is not available");
//       let res;
//       try {
//         res = await fetchWithAuth(
//           `${API_URL}/applications/${logActivityApplicant.id}/activity-logs`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               activity_type: activityType,
//               notes: activityNotes,
//               old_status: oldStatus || undefined,
//               new_status: newStatus || undefined,
//             }),
//           }
//         );
//       } catch (err) {
//         // fetchWithAuth throws for 401/403
//         setLogError(err.message || "Failed to log activity");
//         setLogLoading(false);
//         return;
//       }
//       if (!res.ok) {
//         let err;
//         try {
//           err = await res.json();
//         } catch {
//           err = {};
//         }
//         setLogError(err.detail || "Failed to log activity");
//         setLogLoading(false);
//         return;
//       }
//       // 2. If status_change and newStatus !== oldStatus, PATCH application
//       if (
//         activityType === "status_change" &&
//         newStatus &&
//         newStatus !== oldStatus
//       ) {
//         const fetcher = window.fetchWithAuth || fetchWithAuth;
//         const patchRes = await fetcher(
//           `${API_URL}/applications/${logActivityApplicant.id}`,
//           {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );
//         if (!patchRes.ok) {
//           const err = await patchRes.json();
//           throw new Error(err.detail || "Failed to update application status");
//         }
//       }
//       setLogActivityOpen(false);
//       setActivityType("note");
//       setActivityNotes("");
//       setOldStatus("");
//       setNewStatus("");
//       // Refresh activity logs for this applicant
//       setActivityLogs((prev) => ({
//         ...prev,
//         [logActivityApplicant.id]: undefined,
//       }));
//       setExpandedRows((prev) => ({ ...prev, [logActivityApplicant.id]: true }));
//       fetchJobOrder();

//       // window.location.reload();
//     } catch (e) {
//       setLogError(e.message || "Failed to log activity");
//     } finally {
//       setLogLoading(false);
//     }
//   }

//   const handleTypeChange = (e) => setActivityType(e.target.value);
//   const handleNotesChange = (e) => setActivityNotes(e.target.value);
//   const handleOldStatusChange = (e) => setOldStatus(e.target.value);
//   const handleNewStatusChange = (e) => setNewStatus(e.target.value);

//   const activityTypes = [
//     { value: "note", label: "Note" },
//     { value: "status_change", label: "Status Change" },
//     { value: "email", label: "Email" },
//     { value: "call", label: "Call" },
//     { value: "meeting", label: "Meeting" },
//   ];

//   const renderLogActivityModal = () => (
//     <Dialog
//       open={logActivityOpen}
//       onClose={handleCloseLogActivity}
//       maxWidth="sm"
//       fullWidth
//     >
//       <DialogTitle>
//         Log Activity for {logActivityApplicant?.applicant_name || ""}
//       </DialogTitle>
//       <DialogContent dividers>
//         <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
//           <FormControl fullWidth>
//             <InputLabel id="activity-type-label">Activity Type</InputLabel>
//             <Select
//               labelId="activity-type-label"
//               value={activityType}
//               label="Activity Type"
//               onChange={handleTypeChange}
//               size="small"
//             >
//               {activityTypes.map((type) => (
//                 <MenuItem key={type.value} value={type.value}>
//                   {type.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           {activityType === "status_change" && (
//             <Box sx={{ display: "flex", gap: 2 }}>
//               <TextField
//                 label="Old Status"
//                 value={oldStatus}
//                 size="small"
//                 fullWidth
//                 InputProps={{ readOnly: true }}
//               />
//               <FormControl fullWidth size="small">
//                 <InputLabel id="new-status-label">New Status</InputLabel>
//                 <Select
//                   labelId="new-status-label"
//                   value={newStatus}
//                   label="New Status"
//                   onChange={handleNewStatusChange}
//                   disabled={statusOptionsLoading}
//                   error={!!statusOptionsError}
//                 >
//                   {statusOptionsLoading ? (
//                     <MenuItem value="" disabled>
//                       <CircularProgress size={18} sx={{ mr: 1 }} /> Loading...
//                     </MenuItem>
//                   ) : statusOptionsError ? (
//                     <MenuItem value="" disabled>
//                       {statusOptionsError}
//                     </MenuItem>
//                   ) : (
//                     statusOptions.map((status) => (
//                       <MenuItem
//                         key={status.id || status.value || status.name}
//                         value={status.value || status.name || status.id}
//                       >
//                         {status.label || status.name || status.value}
//                       </MenuItem>
//                     ))
//                   )}
//                 </Select>
//               </FormControl>
//             </Box>
//           )}
//           <TextField
//             label="Notes"
//             value={activityNotes}
//             onChange={handleNotesChange}
//             size="small"
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={6}
//           />
//           {logError && <Typography color="error">{logError}</Typography>}
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={handleCloseLogActivity} disabled={logLoading}>
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmitLogActivity}
//           variant="contained"
//           disabled={logLoading}
//         >
//           {logLoading ? <CircularProgress size={20} /> : "Log Activity"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );

//   // Sequential data loading effect
//   useEffect(() => {
//     let isMounted = true;

//     async function loadSequentially() {
//       // Reset all section states
//       setJobOrderLoading(true);
//       setJobOrderError("");
//       setQuestionsLoading(false);
//       setQuestionsError("");
//       setCandidatesLoading(false);
//       setCandidatesError("");

//       // Set legacy loading state for backward compatibility
//       setLoading(true);
//       setError("");

//       try {
//         const fetcher = window.fetchWithAuth || fetchWithAuth;
//         if (!fetcher) throw new Error("fetchWithAuth is not available");

//         // 1. Load Job Order
//         const res = await fetcher(`${API_URL}/job-orders/${id}`);
//         if (!res.ok) {
//           if (res.status === 403) {
//             const errorMsg =
//               "You are not authorized to perform this action. Please contact your system administrator.";
//             setJobOrderError(errorMsg);
//             setError(errorMsg);
//             return;
//           }
//           throw new Error("Failed to fetch job order");
//         }

//         const data = await res.json();
//         const jobOrderObj = Array.isArray(data) ? data[0] || null : data;

//         if (!isMounted) return;
//         setJobOrder(jobOrderObj);
//         setJobOrderLoading(false);

//         if (!jobOrderObj) {
//           throw new Error("Job order not found");
//         }

//         // 2. Load Job details if available
//         if (jobOrderObj.job_id) {
//           const jobRes = await fetcher(`${API_URL}/jobs/${jobOrderObj.job_id}`);
//           if (jobRes.ok) {
//             const jobData = await jobRes.json();
//             if (isMounted) setJob(jobData);
//           }
//         }

//         // 3. Load Questions (simulate with short delay)
//         if (isMounted) {
//           setQuestionsLoading(true);
//           setQuestionsLoaded(false);
//           // Small delay to show loading state
//           await new Promise((resolve) => setTimeout(resolve, 1000));
//           setQuestionsLoading(false);
//           setQuestionsLoaded(true);
//         }

//         // 4. Load Candidates/Applications (simulate with short delay)
//         if (isMounted && questionsLoaded) {
//           setCandidatesLoading(true);
//           setCandidatesLoaded(false);
//           // Small delay to show loading state
//           await new Promise((resolve) => setTimeout(resolve, 1000));
//           setCandidatesLoading(false);
//           setCandidatesLoaded(true);
//         }

//         // Update legacy loading state
//         if (isMounted) {
//           setLoading(false);
//         }
//       } catch (e) {
//         if (!isMounted) return;

//         // Update the appropriate section error
//         if (jobOrderLoading) {
//           setJobOrderError(e.message);
//           setJobOrderLoading(false);
//         } else if (questionsLoading) {
//           setQuestionsError(e.message);
//           setQuestionsLoading(false);
//         } else if (candidatesLoading) {
//           setCandidatesError(e.message);
//           setCandidatesLoading(false);
//         }

//         // Update legacy error state
//         setError(e.message);
//         setLoading(false);
//       }
//     }

//     loadSequentially();

//     // Cleanup function
//     return () => {
//       isMounted = false;
//     };
//   }, [id]);

//   // Function to refresh job order data
//   const fetchJobOrder = async () => {
//     setJobOrderLoading(true);
//     setJobOrderError("");
//     try {
//       const fetcher = window.fetchWithAuth || fetchWithAuth;
//       if (!fetcher) throw new Error("fetchWithAuth is not available");
//       const res = await fetcher(`${API_URL}/job-orders/${id}`);
//       if (!res.ok) {
//         if (res.status === 403) {
//           setJobOrderError(
//             "You are not authorized to perform this action. Please contact your system administrator."
//           );
//           return;
//         }
//         throw new Error("Failed to fetch job order");
//       }
//       const data = await res.json();
//       const jobOrderObj = Array.isArray(data) ? data[0] || null : data;
//       setJobOrder(jobOrderObj);
//     } catch (e) {
//       setJobOrderError(e.message);
//     } finally {
//       setJobOrderLoading(false);
//     }
//   };

//   // Fetch activity logs when a row is expanded and not yet loaded
//   useEffect(() => {
//     Object.entries(expandedRows).forEach(([appId, isOpen]) => {
//       if (
//         isOpen &&
//         appId &&
//         !activityLogs[appId] &&
//         !activityLogsLoading[appId]
//       ) {
//         setActivityLogsLoading((prev) => ({ ...prev, [appId]: true }));
//         setActivityLogsError((prev) => ({ ...prev, [appId]: "" }));
//         const fetcher = window.fetchWithAuth || fetchWithAuth;
//         fetcher(`${API_URL}/applications/${appId}/activity-logs`)
//           .then((res) => {
//             if (!res.ok) throw new Error("Failed to fetch activity logs");
//             return res.json();
//           })
//           .then((data) => {
//             setActivityLogs((prev) => ({
//               ...prev,
//               [appId]: data.activity_logs || data || [],
//             }));
//             // Cache job order titles for logs
//             const missingIds = Array.from(
//               new Set(
//                 (data.activity_logs || data || [])
//                   .map((act) => act.job_order_id)
//                   .filter((id) => id && !jobOrderTitles[id])
//               )
//             );
//             if (missingIds.length > 0) {
//               Promise.all(
//                 missingIds.map((id) =>
//                   fetch(`${API_URL}/job-orders/${id}`)
//                     .then((res) => (res.ok ? res.json() : null))
//                     .then((data) => ({
//                       id,
//                       title: data?.title || `Job Order ${id}`,
//                     }))
//                     .catch(() => ({ id, title: `Job Order ${id}` }))
//                 )
//               ).then((results) => {
//                 setJobOrderTitles((prev) => {
//                   const next = { ...prev };
//                   results.forEach(({ id, title }) => {
//                     next[id] = title;
//                   });
//                   return next;
//                 });
//               });
//             }
//           })
//           .catch((e) => {
//             setActivityLogsError((prev) => ({ ...prev, [appId]: e.message }));
//             setActivityLogs((prev) => ({ ...prev, [appId]: [] }));
//           })
//           .finally(() => {
//             setActivityLogsLoading((prev) => ({ ...prev, [appId]: false }));
//           });
//       }
//     });
//   }, [expandedRows]);

//   // Main loading and error states
//   if (loading && jobOrderLoading)
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           height: "100vh",
//         }}
//       >
//         <CircularProgress size={40} />
//         <Typography sx={{ mt: 2 }}>Loading job order details...</Typography>
//       </Box>
//     );
//   if (error || jobOrderError)
//     return (
//       <Box p={4}>
//         <Typography color="error">{error || jobOrderError}</Typography>
//       </Box>
//     );
//   if (!jobOrder)
//     return (
//       <Box p={4}>
//         <Typography>Job order not found.</Typography>
//       </Box>
//     );

//   // Example applicant data (replace with real API call in future)
//   const applicants = jobOrder.applications || [];
//   // Only use applicants with a valid id
//   const applicantsWithId = applicants.filter((a) => a && a.id);

//   // --- Search Logic ---
//   const filteredApplicants = (jobOrder.applications || [])
//     .filter((a) => a && a.id)
//     .filter((a) => {
//       if (!searchQuery) return true;
//       const q = searchQuery.toLowerCase();
//       return (
//         (a.applicant_name && a.applicant_name.toLowerCase().includes(q)) ||
//         (a.applicant_email && a.applicant_email.toLowerCase().includes(q)) ||
//         (a.status && a.status.toLowerCase().includes(q))
//       );
//     });

//   // --- Pagination Logic ---
//   const paginatedApplicants = filteredApplicants.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   let applicantRows = [];
//   if (filteredApplicants.length === 0) {
//     applicantRows.push(
//       <TableRow key="no-applicants">
//         <TableCell colSpan={8} align="center">
//           <Typography color="text.secondary">No applicants found.</Typography>
//         </TableCell>
//       </TableRow>
//     );
//   } else {
//     paginatedApplicants.forEach((a, idx) => {
//       let statusColor = "default";
//       if (a.status) {
//         if (/interview/i.test(a.status)) statusColor = "success";
//         else if (/qualify/i.test(a.status)) statusColor = "warning";
//         else if (/no contact/i.test(a.status)) statusColor = "default";
//         else statusColor = "info";
//       }
//       const open = expandedRows[a.id] || false;
//       applicantRows.push(
//         <TableRow
//           key={a.id}
//           sx={{
//             backgroundColor: idx % 2 === 0 ? "#fafbfc" : "#fff",
//             "&:hover": { backgroundColor: "#e3f2fd" },
//           }}
//         >
//           <TableCell>
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <IconButton size="small" onClick={() => handleToggleExpand(a.id)}>
//                 {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//               </IconButton>
//               {a.resume_url && (
//                 <Tooltip title="View Resume">
//                   <IconButton
//                     size="small"
//                     href={a.resume_url}
//                     target="_blank"
//                     rel="noopener"
//                   >
//                     <DownloadIcon fontSize="small" />
//                   </IconButton>
//                 </Tooltip>
//               )}
//             </Box>
//           </TableCell>
//           <TableCell>
//             <AIEvalStatusCell aiEvalStatus={aiEvalStatus} appId={a.id} />
//           </TableCell>
//           <TableCell>
//             <AIEvalScoreCell aiEvalStatus={aiEvalStatus} appId={a.id} />
//           </TableCell>
//           <TableCell>
//             <Button
//               variant="text"
//               sx={{
//                 fontWeight: 700,
//                 color: "#1976d2",
//                 textTransform: "none",
//                 textDecoration: "underline",
//                 cursor: "pointer",
//                 "&:hover": { color: "#1254a1", background: "transparent" },
//               }}
//               onClick={() =>
//                 navigate(
//                   `/admin/job-orders/${jobOrder.id}/candidates?selected=${a.id}`
//                 )
//               }
//             >
//               {a.applicant_name}
//             </Button>
//           </TableCell>
//           <TableCell>
//             <a
//               href={`mailto:${a.applicant_email}`}
//               style={{ color: "#1976d2", textDecoration: "underline" }}
//             >
//               {a.applicant_email}
//             </a>
//           </TableCell>

//           <TableCell>
//             {a.submitted_at
//               ? new Date(a.submitted_at).toLocaleDateString("en-GB")
//               : "-"}
//           </TableCell>
//           <TableCell>
//             <Chip
//               label={a.status || "-"}
//               color={statusColor}
//               size="small"
//               variant="outlined"
//               sx={{ fontWeight: 600, textTransform: "capitalize" }}
//             />
//           </TableCell>
//           <TableCell>
//             <Tooltip title="Log Activity">
//               <IconButton size="small" onClick={() => handleOpenLogActivity(a)}>
//                 <NoteAddIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Reject Applicant">
//               <IconButton
//                 size="small"
//                 color="error"
//                 onClick={() => {
//                   setRejectApplicant(a);
//                   setRejectDialogOpen(true);
//                   setRejectError("");
//                 }}
//               >
//                 <DeleteIcon fontSize="small" />
//               </IconButton>
//             </Tooltip>
//             <Tooltip title="Screen with AI">
//               <span>
//                 <IconButton size="small" onClick={() => handleScreenWithAI(a)}>
//                   {!aiEvalStatus[a.id] || !aiEvalStatus[a.id].status ? (
//                     <SmartToyIcon
//                       fontSize="small"
//                       sx={{
//                         color: "#43A047",
//                         animation: "ai-bounce 1s infinite",
//                         "@keyframes ai-bounce": {
//                           "0%, 100%": { transform: "translateY(0)" },
//                           "50%": { transform: "translateY(-6px)" },
//                         },
//                       }}
//                       titleAccess="No AI evaluation yet! Click to screen."
//                     />
//                   ) : (
//                     <SmartToyIcon fontSize="small" />
//                   )}
//                 </IconButton>
//               </span>
//             </Tooltip>
//           </TableCell>
//         </TableRow>
//       );
//       applicantRows.push(
//         <TableRow key={a.id + "-expand"}>
//           <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
//             <Collapse in={open} timeout="auto" unmountOnExit>
//               <Box sx={{ margin: 1 }}>
//                 <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                   Activity History
//                 </Typography>
//                 {activityLogsLoading[a.id] ? (
//                   <Box
//                     sx={{ display: "flex", justifyContent: "center", py: 2 }}
//                   >
//                     <CircularProgress size={20} />
//                   </Box>
//                 ) : activityLogsError[a.id] ? (
//                   <Typography color="error">
//                     {activityLogsError[a.id]}
//                   </Typography>
//                 ) : activityLogs[a.id] && activityLogs[a.id].length > 0 ? (
//                   <TableContainer component={Paper} sx={{ mb: 2 }}>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow>
//                           <TableCell>Date</TableCell>
//                           <TableCell>Type</TableCell>
//                           <TableCell>Regarding</TableCell>
//                           <TableCell>Notes</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {activityLogs[a.id].map((act, idx) => (
//                           <TableRow key={idx}>
//                             <TableCell>
//                               {act.created_at ? (
//                                 new Date(act.created_at).toLocaleString()
//                               ) : (
//                                 <em>Unknown</em>
//                               )}
//                             </TableCell>
//                             <TableCell>
//                               {act.activity_type || act.type}
//                             </TableCell>
//                             <TableCell>
//                               {act.job_order_id &&
//                               jobOrderTitles[act.job_order_id]
//                                 ? `${jobOrderTitles[act.job_order_id]}${
//                                     act.old_status || act.new_status ? ` ` : ""
//                                   }`
//                                 : act.old_status || act.new_status
//                                 ? `${act.old_status || ""} → ${
//                                     act.new_status || ""
//                                   }`
//                                 : ""}
//                             </TableCell>
//                             <TableCell>
//                               {act.activity_type === "status_change" &&
//                               (act.new_status || act.old_status)
//                                 ? `Status changed from ${
//                                     act.old_status || ""
//                                   } to ${act.new_status || ""} ${
//                                     act.notes ? `: ${act.notes}` : ""
//                                   }`
//                                 : act.notes}
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 ) : (
//                   <Typography variant="body2" color="text.secondary">
//                     No activity found.
//                   </Typography>
//                 )}
//               </Box>
//             </Collapse>
//           </TableCell>
//         </TableRow>
//       );
//     });
//   }

//   /**
//    * Submit the resume+job JSON to the AI analysis endpoint
//    * Shows loading, error, and result states in the modal
//    */

//   const handleSubmitAnalyze = async () => {
//     if (!aiModalJson) return;
//     setAnalyzeLoading(true);
//     setAnalyzeError("");
//     setAnalyzeResult(null);

//     try {
//       const fetcher = window.fetchWithAuth || fetchWithAuth;
//       if (!fetcher) throw new Error("fetchWithAuth is not available");

//       const res = await fetcher(`${API_URL}/ai/analyze-resume-text/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(aiModalJson),
//       });

//       const data = await res.json().catch(() => ({}));

//       if (!res.ok) {
//         throw new Error(data?.detail || "Failed to analyze resume");
//       }

//       // Optional: log activity (keep, but do it after success)
//       if (aiModalJson?.application_id) {
//         fetcher(`${API_URL}/applications/${aiModalJson.application_id}/activity-logs`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ activity_type: "note", notes: "Resume scanned and analyzed using AI." }),
//         }).catch(() => {});
//       }

//       setAnalyzeResult(data);
//       setAiModalOpen(false);

//       // Best: refresh just the job order + evals (no full reload)
//       await fetchJobOrder();

//       // If you insist on reload, do it here:
//       // window.location.reload();

//     } catch (e) {
//       setAnalyzeError(e.message || "Failed to analyze resume");
//     } finally {
//       setAnalyzeLoading(false);
//     }
//   };


//   return (
//     <Box sx={{ display: "flex" }}>
//       <AdminSidebar selected="Job Orders" />
//       <Box
//         component="main"
//         sx={{ flexGrow: 1, p: 3, background: "#f8f9fb", minHeight: "100vh" }}
//       >
//         <Container maxWidth={false} sx={{ width: "100%", mt: 7, mb: 4 }}>
//           <Paper sx={{ p: 3, mb: 3 }}>
//             <Button
//               startIcon={<ArrowBackIcon />}
//               onClick={() => navigate(-1)}
//               sx={{ mb: 2 }}
//             >
//               Back
//             </Button>
//             <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
//               {jobOrder.title || "Job Order Detail"}
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Job Title:
//                 </Typography>
//                 <Typography>{jobOrder.title || job?.title || "-"}</Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Location:
//                 </Typography>
//                 <Typography>
//                   <Box
//                     sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}
//                   >
//                     {(jobOrder.locations && jobOrder.locations.length > 0
//                       ? jobOrder.locations
//                       : job?.locations && job?.locations.length > 0
//                       ? job?.locations
//                       : []
//                     ).length > 0 ? (
//                       (jobOrder.locations && jobOrder.locations.length > 0
//                         ? jobOrder.locations
//                         : job?.locations || []
//                       ).map((loc, idx) => (
//                         <Chip
//                           key={loc.id || loc.name || idx}
//                           label={loc.name}
//                           color={
//                             [
//                               "primary",
//                               "secondary",
//                               "success",
//                               "warning",
//                               "info",
//                               "error",
//                             ][idx % 6]
//                           }
//                           variant="filled"
//                         />
//                       ))
//                     ) : (
//                       <Chip label="-" color="default" variant="outlined" />
//                     )}
//                   </Box>
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Type:
//                 </Typography>
//                 <Typography>
//                   <Box
//                     sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}
//                   >
//                     {(jobOrder.job_types && jobOrder.job_types.length > 0
//                       ? jobOrder.job_types
//                       : job?.job_types && job?.job_types.length > 0
//                       ? job?.job_types
//                       : []
//                     ).length > 0 ? (
//                       (jobOrder.job_types && jobOrder.job_types.length > 0
//                         ? jobOrder.job_types
//                         : job?.job_types || []
//                       ).map((type, idx) => (
//                         <Chip
//                           key={type.id || type.name || idx}
//                           label={type.name}
//                           color={
//                             [
//                               "primary",
//                               "secondary",
//                               "success",
//                               "warning",
//                               "info",
//                               "error",
//                             ][idx % 6]
//                           }
//                           variant="filled"
//                         />
//                       ))
//                     ) : (
//                       <Chip label="-" color="default" variant="outlined" />
//                     )}
//                   </Box>
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Number of Vacancies:
//                 </Typography>
//                 <Typography>
//                   {jobOrder.openings || job?.openings || "-"}
//                 </Typography>

//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Created:
//                 </Typography>
//                 <Typography>
//                   {jobOrder.created_at
//                     ? new Date(jobOrder.created_at).toLocaleString()
//                     : job?.created_at
//                     ? new Date(job.created_at).toLocaleString()
//                     : "-"}
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Recruiter:
//                 </Typography>
//                 <Typography>
//                   <Box sx={{ mb: 1 }}>
//                     {(jobOrder.recruiters && jobOrder.recruiters.length > 0
//                       ? jobOrder.recruiters
//                       : job?.recruiters && job?.recruiters.length > 0
//                       ? job?.recruiters
//                       : []
//                     ).length > 0 ? (
//                       <ol style={{ paddingLeft: 20, margin: 0 }}>
//                         {(jobOrder.recruiters && jobOrder.recruiters.length > 0
//                           ? jobOrder.recruiters
//                           : job?.recruiters || []
//                         ).map((rec, idx) => (
//                           <li
//                             key={rec.id || rec.full_name || idx}
//                             style={{
//                               listStyle: "decimal inside",
//                               marginBottom: 4,
//                             }}
//                           >
//                             <Chip
//                               label={rec.full_name}
//                               color={
//                                 [
//                                   "primary",
//                                   "secondary",
//                                   "success",
//                                   "warning",
//                                   "info",
//                                   "error",
//                                 ][idx % 6]
//                               }
//                               variant="filled"
//                             />
//                           </li>
//                         ))}
//                       </ol>
//                     ) : (
//                       <Chip label="-" color="default" variant="outlined" />
//                     )}
//                   </Box>
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Start Date:
//                 </Typography>
//                 <Typography>
//                   {jobOrder.start_date
//                     ? new Date(jobOrder.start_date).toLocaleString()
//                     : "-"}
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   End Date:
//                 </Typography>
//                 <Typography>
//                   {jobOrder.end_date
//                     ? new Date(jobOrder.end_date).toLocaleString()
//                     : "-"}
//                 </Typography>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Days Active:
//                 </Typography>
//                 <Typography>
//                   {jobOrder.start_date
//                     ? calculateDaysActive(jobOrder.start_date, jobOrder.end_date)
//                     : "-"}
//                 </Typography>

//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Number of Applications:
//                 </Typography>
//                 {/* Show the count of applications for this job order */}
//                 <Typography>
//                   {Array.isArray(jobOrder.applications)
//                     ? jobOrder.applications.length
//                     : 0}
//                 </Typography>

//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Attachments:
//                 </Typography>
//                 <Box sx={{ mb: 2 }}>
//                   {jobOrder.attachments && jobOrder.attachments.length > 0 ? (
//                     jobOrder.attachments.map((att, i) => (
//                       <Button
//                         key={i}
//                         href={att.url}
//                         startIcon={<DownloadIcon />}
//                         target="_blank"
//                         rel="noopener"
//                         sx={{ mr: 1 }}
//                       >
//                         {att.name || `Attachment ${i + 1}`}
//                       </Button>
//                     ))
//                   ) : (
//                     <Typography variant="body2" color="text.secondary">
//                       No attachments.
//                     </Typography>
//                   )}
//                 </Box>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 800 }}>
//                   Internal Notes:
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ minHeight: 40, mb: 1 }}
//                 >
//                   {jobOrder.internal_notes || <em>None</em>}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={8} sx={{ mb: 2 }}>
//                 <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 900 }}>
//                   Description:
//                 </Typography>
//                 <Box
//                   sx={{
//                     p: 2,
//                     border: "1px solid #eee",
//                     borderRadius: 1,
//                     background: "#fafafa",
//                     maxHeight: 600,
//                     overflow: "auto",
//                     mb: 1,
//                   }}
//                 >
//                   <span
//                     dangerouslySetInnerHTML={{
//                       __html: cleanJobDescription(
//                         job?.description
//                           ? `<b>Job Description:</b><br/>${job.description}`
//                           : jobOrder.description || "<em>No description</em>"
//                       ),
//                     }}
//                   />
//                 </Box>
//               </Grid>
//             </Grid>
//             <Typography variant="h6" sx={{ fontWeight: 700, mt: 3 }}>
//               Questions:
//             </Typography>
//             {questionsLoading ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
//                 <CircularProgress size={24} />
//                 <Typography sx={{ ml: 2 }}>Loading questions...</Typography>
//               </Box>
//             ) : questionsError ? (
//               <Alert severity="error">{questionsError}</Alert>
//             ) : (
//               questionsLoaded &&
//               !questionsLoading &&
//               !questionsError && (
//                 <TableContainer>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Text</TableCell>
//                         <TableCell>Description</TableCell>
//                         <TableCell>Type</TableCell>
//                         <TableCell>Required</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {jobOrder.questions && jobOrder.questions.length > 0 ? (
//                         jobOrder.questions.map((q, idx) => (
//                           <TableRow key={q.id || idx}>
//                             <TableCell>{q.text}</TableCell>
//                             <TableCell>
//                               {q.description || (
//                                 <span style={{ color: "#888" }}>
//                                   <em>No description</em>
//                                 </span>
//                               )}
//                             </TableCell>
//                             <TableCell>{q.type}</TableCell>
//                             <TableCell>
//                               {q.is_required ? "Yes" : "No"}
//                             </TableCell>
//                           </TableRow>
//                         ))
//                       ) : (
//                         <TableRow>
//                           <TableCell colSpan={4}>
//                             <Typography>No questions found.</Typography>
//                           </TableCell>
//                         </TableRow>
//                       )}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               )
//             )}
//             <Paper variant="outlined" sx={{ p: 3, boxShadow: 2 }}>
//               {candidatesLoaded && !candidatesLoading && !candidatesError && (
//                 <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
//                   Candidates in Job Order
//                 </Typography>
//               )}
//               {candidatesLoading ? (
//                 <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
//                   <CircularProgress size={24} />
//                   <Typography sx={{ ml: 2 }}>Loading candidates...</Typography>
//                 </Box>
//               ) : candidatesError ? (
//                 <Alert severity="error">{candidatesError}</Alert>
//               ) : (
//                 <React.Fragment>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <TextField
//                       label="Search Candidates"
//                       variant="outlined"
//                       size="small"
//                       value={searchQuery}
//                       onChange={(e) => {
//                         setSearchQuery(e.target.value);
//                         setPage(0); // Reset to first page on search
//                       }}
//                       sx={{ width: 320 }}
//                     />
//                   </Box>
//                   <TableContainer>
//                     <Table size="small" sx={{ minWidth: 700 }}>
//                       <TableHead>
//                         <TableRow sx={{ background: "#f5f6fa" }}>
//                           <TableCell sx={{ fontWeight: 700 }}></TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>Match</TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>
//                             Match Score
//                           </TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>
//                             Applicant Name
//                           </TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>
//                             Applicant Email
//                           </TableCell>
//                           {/* <TableCell sx={{ fontWeight: 700 }}>Location</TableCell> */}
//                           <TableCell sx={{ fontWeight: 700 }}>Added</TableCell>
//                           <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
//                           <TableCell sx={{ fontWeight: 700, width: "150px" }}>
//                             Action
//                           </TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>{applicantRows}</TableBody>
//                     </Table>
//                   </TableContainer>
//                   <TablePagination
//                     component="div"
//                     count={filteredApplicants.length}
//                     page={page}
//                     onPageChange={(e, newPage) => setPage(newPage)}
//                     rowsPerPage={rowsPerPage}
//                     onRowsPerPageChange={(e) => {
//                       setRowsPerPage(parseInt(e.target.value, 10));
//                       setPage(0);
//                     }}
//                     rowsPerPageOptions={[5, 10, 25, 50]}
//                     labelRowsPerPage="Rows per page:"
//                   />
//                 </React.Fragment>
//               )}
//             </Paper>
//           </Paper>
//         </Container>
//         {renderLogActivityModal()}

//         {/* Reject Confirmation Modal */}
//         <Dialog
//           open={rejectDialogOpen}
//           onClose={() => {
//             if (!rejecting) setRejectDialogOpen(false);
//           }}
//           maxWidth="xs"
//           fullWidth
//         >
//           <DialogTitle>Reject Applicant</DialogTitle>
//           <DialogContent dividers>
//             <Typography>
//               Are you sure you want to reject applicant{" "}
//               <b>{rejectApplicant?.applicant_name}</b>? This will notify the
//               applicant and remove them from consideration.
//             </Typography>
//             {rejectError && (
//               <Typography color="error" sx={{ mt: 1 }}>
//                 {rejectError}
//               </Typography>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button
//               onClick={() => setRejectDialogOpen(false)}
//               disabled={rejecting}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={async () => {
//                 if (!rejectApplicant?.id) return;
//                 setRejecting(true);
//                 setRejectError("");
//                 try {
//                   const fetcher = window.fetchWithAuth || fetchWithAuth;
//                   if (!fetcher)
//                     throw new Error("fetchWithAuth is not available");
//                   const res = await fetcher(
//                     `${API_URL}/applications/${rejectApplicant.id}/reject`,
//                     {
//                       method: "POST",
//                       headers: { "Content-Type": "application/json" },
//                     }
//                   );
//                   if (!res.ok) {
//                     const err = await res.json();
//                     throw new Error(err.detail || "Failed to reject applicant");
//                   }
//                   setSnackbar({
//                     open: true,
//                     message: "Applicant rejected successfully",
//                     severity: "success",
//                   });
//                   setRejectDialogOpen(false);
//                   setRejectApplicant(null);
//                   fetchJobOrder();
//                 } catch (e) {
//                   setRejectError(e.message || "Failed to reject applicant");
//                 } finally {
//                   setRejecting(false);
//                 }
//               }}
//               color="error"
//               variant="contained"
//               disabled={rejecting}
//             >
//               {rejecting ? <CircularProgress size={20} /> : "Reject"}
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         >
//           <Alert
//             onClose={() => setSnackbar({ ...snackbar, open: false })}
//             severity={snackbar.severity}
//             sx={{ width: "100%" }}
//           >
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         {/* --- AI Resume Modal --- */}
//         <Dialog
//           open={aiModalOpen}
//           onClose={handleCloseAiModal}
//           maxWidth="md"
//           fullWidth
//         >
//           <DialogTitle>
//             Resume & Job JSON for{" "}
//             {aiModalApplicant?.applicant_name || "Applicant"}
//           </DialogTitle>
//           <DialogContent dividers>
//             {aiModalLoading ? (
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   minHeight: 180,
//                 }}
//               >
//                 <CircularProgress />
//               </Box>
//             ) : aiModalError ? (
//               <Typography color="error">{aiModalError}</Typography>
//             ) : aiModalJson ? (
//               <pre
//                 style={{
//                   background: "#f5f5f5",
//                   padding: 16,
//                   borderRadius: 8,
//                   fontSize: 14,
//                   maxHeight: 400,
//                   overflow: "auto",
//                 }}
//               >
//                 {JSON.stringify(aiModalJson, null, 2)}
//               </pre>
//             ) : (
//               <Typography color="text.secondary">No data.</Typography>
//             )}
//             {/* AI Resume Analysis Result */}
//             {analyzeError && (
//               <Typography color="error" sx={{ mt: 2 }}>
//                 {analyzeError}
//               </Typography>
//             )}
//             {analyzeResult && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                   AI Analysis Result
//                 </Typography>
//                 <pre
//                   style={{
//                     background: "#f0f7fa",
//                     padding: 12,
//                     borderRadius: 6,
//                     fontSize: 14,
//                     maxHeight: 300,
//                     overflow: "auto",
//                   }}
//                 >
//                   {typeof analyzeResult === "string"
//                     ? analyzeResult
//                     : JSON.stringify(analyzeResult, null, 2)}
//                 </pre>
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseAiModal}>Close</Button>
//             {/* Analyze Resume button submits JSON to AI endpoint */}
//             <Button
//               onClick={handleSubmitAnalyze}
//               variant="contained"
//               disabled={analyzeLoading}
//             >
//               {analyzeLoading ? (
//                 <CircularProgress size={20} />
//               ) : (
//                 "Analyze Resume"
//               )}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     </Box>
//   );
// }

// export default JobOrderDetail;

import React, { useEffect, useMemo, useState } from "react";
import cleanJobDescription from "../cleanJobDescription";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Typography,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import DownloadIcon from "@mui/icons-material/Download";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AdminSidebar from "../AdminSidebar";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../App";
import { API_URL } from "../config";
import { AIEvalScoreCell, AIEvalStatusCell } from "./JobOrderDetailAIStatus";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box sx={{ width: 24, height: 2, borderRadius: 2, bgcolor: "currentColor" }} />
      {children}
    </Box>
  );
}

function calculateDaysActive(startDate, endDate) {
  if (!startDate) return "-";
  try {
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date();
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return "-";
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    if (end < start) return 0;
    return Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
  } catch {
    return "-";
  }
}

function useJobOrderAIEvalStatus(appIds, jobOrderId, fetchWithAuth) {
  const [aiEvalStatus, setAiEvalStatus] = useState({});

  const stableAppIds = useMemo(() => {
    if (!Array.isArray(appIds)) return [];
    return Array.from(new Set(appIds.filter(Boolean))).sort();
  }, [JSON.stringify(appIds || [])]);

  const appIdsKey = useMemo(() => stableAppIds.join(","), [stableAppIds]);

  useEffect(() => {
    if (!jobOrderId || stableAppIds.length === 0) {
      setAiEvalStatus({});
      return;
    }

    let cancelled = false;

    setAiEvalStatus((prev) => {
      const next = { ...prev };

      stableAppIds.forEach((appId) => {
        if (!next[appId]) {
          next[appId] = {
            loading: true,
            error: null,
            status: null,
            match_score: null,
          };
        }
      });

      return next;
    });

    Promise.all(
      stableAppIds.map(async (appId) => {
        try {
          const res = await fetchWithAuth(
            `${API_URL}/ai/evaluations/by-application-job/${appId}/${jobOrderId}`
          );

          if (res.status === 404) {
            return [
              appId,
              {
                loading: false,
                error: null,
                status: null,
                match_score: null,
                strengths: null,
                weaknesses: null,
                summary: null,
                missing_skills: null,
              },
            ];
          }

          if (!res.ok) {
            const text = await res.text().catch(() => "");
            throw new Error(text || `Request failed (${res.status})`);
          }

          const data = await res.json();
          const ev = data?.evaluation || null;

          return [
            appId,
            {
              loading: false,
              error: null,
              status: ev?.status ?? null,
              match_score: ev?.match_score ?? null,
              strengths: ev?.strengths ?? null,
              weaknesses: ev?.weaknesses ?? null,
              summary: ev?.summary ?? null,
              missing_skills: ev?.missing_skills ?? null,
            },
          ];
        } catch (e) {
          return [
            appId,
            {
              loading: false,
              error: e?.message || "Unknown error",
              status: null,
              match_score: null,
              strengths: null,
              weaknesses: null,
              summary: null,
              missing_skills: null,
            },
          ];
        }
      })
    ).then((entries) => {
      if (cancelled) return;

      setAiEvalStatus((prev) => {
        const next = { ...prev };
        for (const [appId, value] of entries) {
          next[appId] = value;
        }
        return next;
      });
    });

    return () => {
      cancelled = true;
    };
  }, [jobOrderId, appIdsKey, fetchWithAuth]);

  return aiEvalStatus;
}

function JobOrderDetail() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const auth = useAuth();
  const { fetchWithAuth } = auth || {};
  const { id } = useParams();
  const navigate = useNavigate();

  const [jobOrder, setJobOrder] = useState(null);
  const [job, setJob] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [activityLogs, setActivityLogs] = useState({});
  const [activityLogsLoading, setActivityLogsLoading] = useState({});
  const [activityLogsError, setActivityLogsError] = useState({});
  const [jobOrderTitles, setJobOrderTitles] = useState({});

  const [logActivityOpen, setLogActivityOpen] = useState(false);
  const [logActivityApplicant, setLogActivityApplicant] = useState(null);
  const [activityType, setActivityType] = useState("note");
  const [activityNotes, setActivityNotes] = useState("");
  const [oldStatus, setOldStatus] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
  const [statusOptionsError, setStatusOptionsError] = useState("");
  const [logLoading, setLogLoading] = useState(false);
  const [logError, setLogError] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [rejectError, setRejectError] = useState("");
  const [rejectApplicant, setRejectApplicant] = useState(null);

  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [aiModalLoading, setAiModalLoading] = useState(false);
  const [aiModalError, setAiModalError] = useState("");
  const [aiModalJson, setAiModalJson] = useState(null);
  const [aiModalApplicant, setAiModalApplicant] = useState(null);
  const [analyzeLoading, setAnalyzeLoading] = useState(false);
  const [analyzeError, setAnalyzeError] = useState("");
  const [analyzeResult, setAnalyzeResult] = useState(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const applicants = (jobOrder?.applications || []).filter((a) => a && a.id);

  const filteredApplicants = applicants.filter((a) => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase();
    return (
      (a.applicant_name && a.applicant_name.toLowerCase().includes(q)) ||
      (a.applicant_email && a.applicant_email.toLowerCase().includes(q)) ||
      (a.status && a.status.toLowerCase().includes(q))
    );
  });

  const paginatedApplicants = filteredApplicants.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const aiEvalAppIds = useMemo(() => {
    return paginatedApplicants.map((a) => a.id).filter(Boolean).sort();
  }, [paginatedApplicants]);

  const aiEvalStatus = useJobOrderAIEvalStatus(aiEvalAppIds, jobOrder?.id, fetchWithAuth);

  const fetchJobOrder = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchWithAuth(`${API_URL}/job-orders/${id}`);
      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error("Failed to fetch job order");
      }

      const data = await res.json();
      const jobOrderObj = Array.isArray(data) ? data[0] || null : data;
      setJobOrder(jobOrderObj);

      if (jobOrderObj?.job_id) {
        const jobRes = await fetchWithAuth(`${API_URL}/jobs/${jobOrderObj.job_id}`);
        if (jobRes.ok) {
          const jobData = await jobRes.json();
          setJob(jobData);
        }
      }
    } catch (e) {
      setError(e.message || "Failed to load job order");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobOrder();
  }, [id]);

  useEffect(() => {
    Object.entries(expandedRows).forEach(([appId, isOpen]) => {
      if (
        isOpen &&
        appId &&
        !activityLogs[appId] &&
        !activityLogsLoading[appId]
      ) {
        setActivityLogsLoading((prev) => ({ ...prev, [appId]: true }));
        setActivityLogsError((prev) => ({ ...prev, [appId]: "" }));

        fetchWithAuth(`${API_URL}/applications/${appId}/activity-logs`)
          .then((res) => {
            if (!res.ok) throw new Error("Failed to fetch activity logs");
            return res.json();
          })
          .then((data) => {
            const logs = data.activity_logs || data || [];
            setActivityLogs((prev) => ({ ...prev, [appId]: logs }));

            const missingIds = Array.from(
              new Set(
                logs
                  .map((act) => act.job_order_id)
                  .filter((jid) => jid && !jobOrderTitles[jid])
              )
            );

            if (missingIds.length > 0) {
              Promise.all(
                missingIds.map((jid) =>
                  fetchWithAuth(`${API_URL}/job-orders/${jid}`)
                    .then((res) => (res.ok ? res.json() : null))
                    .then((data) => ({ id: jid, title: data?.title || `Job Order ${jid}` }))
                    .catch(() => ({ id: jid, title: `Job Order ${jid}` }))
                )
              ).then((results) => {
                setJobOrderTitles((prev) => {
                  const next = { ...prev };
                  results.forEach(({ id, title }) => {
                    next[id] = title;
                  });
                  return next;
                });
              });
            }
          })
          .catch((e) => {
            setActivityLogsError((prev) => ({ ...prev, [appId]: e.message }));
            setActivityLogs((prev) => ({ ...prev, [appId]: [] }));
          })
          .finally(() => {
            setActivityLogsLoading((prev) => ({ ...prev, [appId]: false }));
          });
      }
    });
  }, [expandedRows, activityLogs, activityLogsLoading, jobOrderTitles, fetchWithAuth]);

  useEffect(() => {
    if (!logActivityOpen || activityType !== "status_change") return;

    async function loadStatuses() {
      setStatusOptionsLoading(true);
      setStatusOptionsError("");
      try {
        const res = await fetchWithAuth(`${API_URL}/statuses/`);
        if (!res.ok) throw new Error("Failed to fetch statuses");
        const data = await res.json();
        setStatusOptions(Array.isArray(data) ? data : data.statuses || []);
      } catch (e) {
        setStatusOptionsError(e.message || "Failed to fetch statuses");
      } finally {
        setStatusOptionsLoading(false);
      }
    }

    if (statusOptions.length === 0) loadStatuses();
  }, [logActivityOpen, activityType, statusOptions.length, fetchWithAuth]);

  const handleToggleExpand = (appId) => {
    setExpandedRows((prev) => ({ ...prev, [appId]: !prev[appId] }));
  };

  const handleOpenLogActivity = (applicant) => {
    setLogActivityApplicant(applicant);
    setActivityType("note");
    setActivityNotes("");
    setOldStatus(applicant.status || "");
    setNewStatus("");
    setLogError("");
    setLogActivityOpen(true);
  };

  const handleCloseLogActivity = () => {
    setLogActivityOpen(false);
    setLogActivityApplicant(null);
    setActivityType("note");
    setActivityNotes("");
    setOldStatus("");
    setNewStatus("");
    setLogError("");
  };

  const handleSubmitLogActivity = async () => {
    if (!logActivityApplicant?.id) return;

    setLogLoading(true);
    setLogError("");

    try {
      const res = await fetchWithAuth(
        `${API_URL}/applications/${logActivityApplicant.id}/activity-logs`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            activity_type: activityType,
            notes: activityNotes,
            old_status: oldStatus || undefined,
            new_status: newStatus || undefined,
          }),
        }
      );

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Failed to log activity");
      }

      if (
        activityType === "status_change" &&
        newStatus &&
        newStatus !== oldStatus
      ) {
        const patchRes = await fetchWithAuth(
          `${API_URL}/applications/${logActivityApplicant.id}`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ status: newStatus }),
          }
        );

        if (!patchRes.ok) {
          const err = await patchRes.json().catch(() => ({}));
          throw new Error(err.detail || "Failed to update application status");
        }
      }

      setSnackbar({
        open: true,
        message: "Activity logged successfully",
        severity: "success",
      });

      setActivityLogs((prev) => ({ ...prev, [logActivityApplicant.id]: undefined }));
      setExpandedRows((prev) => ({ ...prev, [logActivityApplicant.id]: true }));
      handleCloseLogActivity();
      fetchJobOrder();
    } catch (e) {
      setLogError(e.message || "Failed to log activity");
    } finally {
      setLogLoading(false);
    }
  };

  const handleScreenWithAI = async (applicant) => {
    setAiModalApplicant(applicant);
    setAiModalOpen(true);
    setAiModalLoading(true);
    setAiModalError("");
    setAiModalJson(null);
    setAnalyzeResult(null);
    setAnalyzeError("");

    try {
      let resumeFileUrl = applicant.resume || null;

      if (resumeFileUrl && resumeFileUrl.startsWith("/uploads")) {
        resumeFileUrl = API_URL.replace(/\/$/, "") + resumeFileUrl;
      }

      if (!resumeFileUrl) {
        throw new Error("No resume file found on applicant record.");
      }

      const res = await fetch(resumeFileUrl);
      if (!res.ok) throw new Error("Failed to fetch resume file.");

      const arrayBuffer = await res.arrayBuffer();
      const ext = resumeFileUrl.split(".").pop().toLowerCase();

      let plainResumeText = "";

      if (ext === "pdf") {
        const pdfjsLib = await import("pdfjs-dist/build/pdf");
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        let textContent = "";

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          textContent += content.items.map((item) => item.str).join(" ") + "\n";
        }

        plainResumeText = textContent;
      } else if (ext === "docx") {
        let mammoth = window.mammoth;
        if (!mammoth) {
          mammoth = await new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "/vendor/mammoth.browser.min.js";
            script.onload = () => resolve(window.mammoth);
            script.onerror = () => reject(new Error("Failed to load mammoth"));
            document.body.appendChild(script);
          });
        }

        const { value } = await mammoth.extractRawText({ arrayBuffer });
        plainResumeText = value;
      } else {
        plainResumeText = new TextDecoder().decode(arrayBuffer);
      }

      plainResumeText = plainResumeText
        .replace(/\u00a0/g, " ")
        .replace(/\r|\t/g, " ")
        .replace(/\n{2,}/g, "\n")
        .replace(/\s{2,}/g, " ")
        .trim();

      const stripHtml = (html) =>
        String(html || "")
          .replace(/<[^>]*>/g, "")
          .replace(/\s+/g, " ")
          .trim();

      const jobDescription = stripHtml(job?.description || jobOrder?.description || "");

      setAiModalJson({
        resume_text: plainResumeText,
        job_description: jobDescription,
        application_id: applicant.id,
        job_order_id: jobOrder.id,
      });
    } catch (e) {
      setAiModalError(e.message || "Failed to extract resume text.");
    } finally {
      setAiModalLoading(false);
    }
  };

  const handleSubmitAnalyze = async () => {
    if (!aiModalJson) return;

    setAnalyzeLoading(true);
    setAnalyzeError("");
    setAnalyzeResult(null);

    try {
      const res = await fetchWithAuth(`${API_URL}/ai/analyze-resume-text/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(aiModalJson),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.detail || "Failed to analyze resume");
      }

      setAnalyzeResult(data);
      setAiModalOpen(false);
      setSnackbar({
        open: true,
        message: "Resume submitted for analysis",
        severity: "success",
      });

      fetchJobOrder();
    } catch (e) {
      setAnalyzeError(e.message || "Failed to analyze resume");
    } finally {
      setAnalyzeLoading(false);
    }
  };

  const applicantRows = paginatedApplicants.flatMap((a, idx) => {
    const open = expandedRows[a.id] || false;
    const statusColor = /interview/i.test(a.status || "")
      ? "success"
      : /qualify/i.test(a.status || "")
      ? "warning"
      : /reject/i.test(a.status || "")
      ? "error"
      : "info";

    return [
      <TableRow
        key={a.id}
        sx={{
          "& td": {
            borderBottom: `1px solid ${border}`,
            background: dark ? "rgba(13,18,32,0.96)" : idx % 2 === 0 ? "#fafbfc" : "#ffffff",
          },
          "&:hover td": {
            background: dark ? "rgba(255,255,255,0.03)" : "#eef4ff",
          },
        }}
      >
        <TableCell>
          <IconButton size="small" onClick={() => handleToggleExpand(a.id)}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          <AIEvalStatusCell aiEvalStatus={aiEvalStatus} appId={a.id} />
        </TableCell>

        <TableCell>
          <AIEvalScoreCell aiEvalStatus={aiEvalStatus} appId={a.id} />
        </TableCell>

        <TableCell>
          <Button
            variant="text"
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: accent,
              p: 0,
              minWidth: 0,
              "&:hover": { background: "transparent", color: accent },
            }}
            onClick={() => navigate(`/admin/job-orders/${jobOrder.id}/candidates?selected=${a.id}`)}
          >
            {a.applicant_name}
          </Button>
        </TableCell>

        <TableCell>
          <a
            href={`mailto:${a.applicant_email}`}
            style={{ color: accent, textDecoration: "underline" }}
          >
            {a.applicant_email}
          </a>
        </TableCell>

        <TableCell>
          {a.submitted_at ? new Date(a.submitted_at).toLocaleDateString("en-GB") : "-"}
        </TableCell>

        <TableCell>
          <Chip
            label={a.status || "-"}
            color={statusColor}
            size="small"
            variant="outlined"
            sx={{ fontWeight: 700, textTransform: "capitalize" }}
          />
        </TableCell>

        <TableCell sx={{ whiteSpace: "nowrap" }}>
          <Tooltip title="Log Activity">
            <IconButton size="small" onClick={() => handleOpenLogActivity(a)}>
              <NoteAddIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Reject Applicant">
            <IconButton
              size="small"
              color="error"
              onClick={() => {
                setRejectApplicant(a);
                setRejectDialogOpen(true);
                setRejectError("");
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Screen with AI">
            <IconButton size="small" onClick={() => handleScreenWithAI(a)}>
              <SmartToyIcon
                fontSize="small"
                sx={{
                  color:
                    !aiEvalStatus[a.id] || !aiEvalStatus[a.id].status
                      ? "#22c55e"
                      : "inherit",
                }}
              />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>,

      <TableRow key={`${a.id}-expand`}>
        <TableCell colSpan={8} sx={{ p: 0, borderBottom: `1px solid ${border}` }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ m: 2 }}>
              <Typography sx={{ mb: 1, fontWeight: 700, color: text }}>
                Activity History
              </Typography>

              {activityLogsLoading[a.id] ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                  <CircularProgress size={20} sx={{ color: accent }} />
                </Box>
              ) : activityLogsError[a.id] ? (
                <Typography color="error">{activityLogsError[a.id]}</Typography>
              ) : activityLogs[a.id] && activityLogs[a.id].length > 0 ? (
                <TableContainer
                  sx={{
                    borderRadius: "16px",
                    border: `1px solid ${border}`,
                    overflow: "hidden",
                  }}
                >
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {["Date", "Type", "Regarding", "Notes"].map((header) => (
                          <TableCell
                            key={header}
                            sx={{
                              fontWeight: 700,
                              color: mid,
                              background: dark ? "#111827" : "#fafafa",
                              borderBottom: `1px solid ${border}`,
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {activityLogs[a.id].map((act, logIdx) => (
                        <TableRow key={logIdx}>
                          <TableCell>{act.created_at ? new Date(act.created_at).toLocaleString() : "Unknown"}</TableCell>
                          <TableCell>{act.activity_type || act.type}</TableCell>
                          <TableCell>
                            {act.job_order_id && jobOrderTitles[act.job_order_id]
                              ? jobOrderTitles[act.job_order_id]
                              : ""}
                          </TableCell>
                          <TableCell>
                            {act.activity_type === "status_change" &&
                            (act.new_status || act.old_status)
                              ? `Status changed from ${act.old_status || ""} to ${act.new_status || ""}${act.notes ? `: ${act.notes}` : ""}`
                              : act.notes}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography sx={{ color: muted }}>No activity found.</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>,
    ];
  });

  if (loading) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Job Orders" />
        <Box
          sx={{
            flex: 1,
            display: "grid",
            placeItems: "center",
          }}
        >
          <CircularProgress sx={{ color: accent }} />
        </Box>
      </Box>
    );
  }

  if (error || !jobOrder) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Job Orders" />
        <Box sx={{ flex: 1, p: 4, mt: 8 }}>
          <Alert severity="error">{error || "Job order not found."}</Alert>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Job Orders" />

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 7, mb: 3 }}>
        <Container maxWidth={false} sx={{ width: "100%", mb: 4 }}>
          <Paper
            sx={{
              p: 3,
              borderRadius: "28px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                mb: 2,
                textTransform: "none",
                fontWeight: 600,
                color: mid,
                "&:hover": { background: "transparent", color: accent },
              }}
            >
              Back
            </Button>

            <SectionEyebrow color={accent}>AjiraHQ · Job Order</SectionEyebrow>

            <Typography
              sx={{
                mt: 2,
                fontWeight: 800,
                fontSize: "clamp(30px, 4vw, 44px)",
                lineHeight: 1.06,
                color: text,
                letterSpacing: "-0.03em",
                mb: 2,
              }}
            >
              {jobOrder.title || "Job Order Detail"}
            </Typography>

            <Divider sx={{ mb: 3, borderColor: border }} />

            <Grid container spacing={3} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={4}>
                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Job Title</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>{jobOrder.title || job?.title || "-"}</Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Location</Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                  {(jobOrder.locations || job?.locations || []).length > 0 ? (
                    (jobOrder.locations || job?.locations || []).map((loc, idx) => (
                      <Chip
                        key={loc.id || loc.name || idx}
                        label={loc.name}
                        sx={{
                          borderRadius: 999,
                          background: dark ? "rgba(255,255,255,0.04)" : "rgba(15,15,26,0.03)",
                          color: mid,
                          border: `1px solid ${border}`,
                        }}
                      />
                    ))
                  ) : (
                    <Chip label="-" variant="outlined" />
                  )}
                </Box>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Type</Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                  {(jobOrder.job_types || job?.job_types || []).length > 0 ? (
                    (jobOrder.job_types || job?.job_types || []).map((type, idx) => (
                      <Chip
                        key={type.id || type.name || idx}
                        label={type.name}
                        sx={{
                          borderRadius: 999,
                          background: dark ? "rgba(255,255,255,0.04)" : "rgba(15,15,26,0.03)",
                          color: mid,
                          border: `1px solid ${border}`,
                        }}
                      />
                    ))
                  ) : (
                    <Chip label="-" variant="outlined" />
                  )}
                </Box>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Vacancies</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>{jobOrder.openings || "-"}</Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Created</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>
                  {jobOrder.created_at
                    ? new Date(jobOrder.created_at).toLocaleString()
                    : job?.created_at
                    ? new Date(job.created_at).toLocaleString()
                    : "-"}
                </Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Recruiters</Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
                  {(jobOrder.recruiters || job?.recruiters || []).length > 0 ? (
                    (jobOrder.recruiters || job?.recruiters || []).map((rec, idx) => (
                      <Chip
                        key={rec.id || rec.full_name || idx}
                        label={rec.full_name}
                        sx={{
                          borderRadius: 999,
                          background: dark ? alpha(accent, 0.14) : alpha(accent, 0.08),
                          color: accent,
                          border: `1px solid ${alpha(accent, 0.2)}`,
                        }}
                      />
                    ))
                  ) : (
                    <Chip label="-" variant="outlined" />
                  )}
                </Box>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Start Date</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>
                  {jobOrder.start_date ? new Date(jobOrder.start_date).toLocaleString() : "-"}
                </Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>End Date</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>
                  {jobOrder.end_date ? new Date(jobOrder.end_date).toLocaleString() : "-"}
                </Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Days Active</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>
                  {jobOrder.start_date
                    ? calculateDaysActive(jobOrder.start_date, jobOrder.end_date)
                    : "-"}
                </Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Applications</Typography>
                <Typography sx={{ color: mid, mb: 2 }}>
                  {Array.isArray(jobOrder.applications) ? jobOrder.applications.length : 0}
                </Typography>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Attachments</Typography>
                <Box sx={{ mb: 2 }}>
                  {jobOrder.attachments && jobOrder.attachments.length > 0 ? (
                    jobOrder.attachments.map((att, i) => (
                      <Button
                        key={i}
                        href={att.url}
                        startIcon={<DownloadIcon />}
                        target="_blank"
                        rel="noopener"
                        sx={{ mr: 1, mb: 1, textTransform: "none" }}
                      >
                        {att.name || `Attachment ${i + 1}`}
                      </Button>
                    ))
                  ) : (
                    <Typography sx={{ color: muted }}>No attachments.</Typography>
                  )}
                </Box>

                <Typography sx={{ mb: 1, fontWeight: 800, color: text }}>Internal Notes</Typography>
                <Typography sx={{ color: mid }}>
                  {jobOrder.internal_notes || <em>None</em>}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8}>
                <Typography sx={{ mb: 1, fontWeight: 900, color: text }}>Description</Typography>
                <Box
                  sx={{
                    p: 2,
                    border: `1px solid ${border}`,
                    borderRadius: "18px",
                    background: dark ? "rgba(255,255,255,0.02)" : "#fafafa",
                    maxHeight: 600,
                    overflow: "auto",
                    mb: 1,
                    color: mid,
                    "& p": { lineHeight: 1.8 },
                    "& strong, & b": { color: text },
                    "& h1, & h2, & h3, & h4": { color: text, fontWeight: 800 },
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: cleanJobDescription(
                        job?.description
                          ? `<b>Job Description:</b><br/>${job.description}`
                          : jobOrder.description || "<em>No description</em>"
                      ),
                    }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Typography sx={{ fontWeight: 800, mt: 3, mb: 2, color: text, fontSize: "1.2rem" }}>
              Questions
            </Typography>

            <TableContainer
              sx={{
                borderRadius: "18px",
                border: `1px solid ${border}`,
                overflow: "hidden",
                mb: 4,
              }}
            >
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {["Text", "Description", "Type", "Required"].map((header) => (
                      <TableCell
                        key={header}
                        sx={{
                          fontWeight: 700,
                          color: mid,
                          background: dark ? "#111827" : "#fafafa",
                          borderBottom: `1px solid ${border}`,
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {jobOrder.questions && jobOrder.questions.length > 0 ? (
                    jobOrder.questions.map((q, idx) => (
                      <TableRow key={q.id || idx}>
                        <TableCell sx={{ color: text, fontWeight: 600 }}>{q.text}</TableCell>
                        <TableCell>{q.description || <em style={{ color: muted }}>No description</em>}</TableCell>
                        <TableCell>{q.type}</TableCell>
                        <TableCell>{q.is_required ? "Yes" : "No"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4}>
                        <Typography sx={{ color: muted }}>No questions found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Paper
              variant="outlined"
              sx={{
                p: 3,
                borderRadius: "22px",
                borderColor: border,
                background: dark ? "rgba(255,255,255,0.01)" : "#ffffff",
              }}
            >
              <Typography sx={{ fontWeight: 800, mb: 2, color: text, fontSize: "1.2rem" }}>
                Candidates in Job Order
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <TextField
                  label="Search Candidates"
                  variant="outlined"
                  size="small"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setPage(0);
                  }}
                  sx={{
                    width: 320,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "14px",
                    },
                  }}
                />
              </Box>

              <TableContainer sx={{ borderRadius: "18px", border: `1px solid ${border}` }}>
                <Table size="small" sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      {["", "Match", "Match Score", "Applicant Name", "Applicant Email", "Added", "Status", "Action"].map(
                        (header) => (
                          <TableCell
                            key={header}
                            sx={{
                              fontWeight: 700,
                              color: mid,
                              background: dark ? "#111827" : "#fafafa",
                              borderBottom: `1px solid ${border}`,
                            }}
                          >
                            {header}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredApplicants.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          <Typography sx={{ color: muted }}>No applicants found.</Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      applicantRows
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={filteredApplicants.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Rows per page:"
                sx={{ color: mid }}
              />
            </Paper>
          </Paper>
        </Container>

        <Dialog open={logActivityOpen} onClose={handleCloseLogActivity} maxWidth="sm" fullWidth>
          <DialogTitle>Log Activity for {logActivityApplicant?.applicant_name || ""}</DialogTitle>
          <DialogContent dividers>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="activity-type-label">Activity Type</InputLabel>
                <Select
                  labelId="activity-type-label"
                  value={activityType}
                  label="Activity Type"
                  onChange={(e) => setActivityType(e.target.value)}
                  size="small"
                >
                  <MenuItem value="note">Note</MenuItem>
                  <MenuItem value="status_change">Status Change</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                  <MenuItem value="call">Call</MenuItem>
                  <MenuItem value="meeting">Meeting</MenuItem>
                </Select>
              </FormControl>

              {activityType === "status_change" && (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField label="Old Status" value={oldStatus} size="small" fullWidth InputProps={{ readOnly: true }} />
                  <FormControl fullWidth size="small">
                    <InputLabel id="new-status-label">New Status</InputLabel>
                    <Select
                      labelId="new-status-label"
                      value={newStatus}
                      label="New Status"
                      onChange={(e) => setNewStatus(e.target.value)}
                      disabled={statusOptionsLoading}
                      error={!!statusOptionsError}
                    >
                      {statusOptionsLoading ? (
                        <MenuItem value="" disabled>
                          <CircularProgress size={18} sx={{ mr: 1 }} />
                          Loading...
                        </MenuItem>
                      ) : statusOptionsError ? (
                        <MenuItem value="" disabled>{statusOptionsError}</MenuItem>
                      ) : (
                        statusOptions.map((status) => (
                          <MenuItem
                            key={status.id || status.value || status.name}
                            value={status.value || status.name || status.id}
                          >
                            {status.label || status.name || status.value}
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </Box>
              )}

              <TextField
                label="Notes"
                value={activityNotes}
                onChange={(e) => setActivityNotes(e.target.value)}
                size="small"
                fullWidth
                multiline
                minRows={2}
                maxRows={6}
              />

              {logError && <Typography color="error">{logError}</Typography>}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseLogActivity} disabled={logLoading}>Cancel</Button>
            <Button onClick={handleSubmitLogActivity} variant="contained" disabled={logLoading}>
              {logLoading ? <CircularProgress size={20} /> : "Log Activity"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={rejectDialogOpen} onClose={() => !rejecting && setRejectDialogOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Reject Applicant</DialogTitle>
          <DialogContent dividers>
            <Typography>
              Are you sure you want to reject applicant <b>{rejectApplicant?.applicant_name}</b>?
            </Typography>
            {rejectError && <Typography color="error" sx={{ mt: 1 }}>{rejectError}</Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRejectDialogOpen(false)} disabled={rejecting}>
              Cancel
            </Button>
            <Button
              color="error"
              variant="contained"
              disabled={rejecting}
              onClick={async () => {
                if (!rejectApplicant?.id) return;
                setRejecting(true);
                setRejectError("");
                try {
                  const res = await fetchWithAuth(
                    `${API_URL}/applications/${rejectApplicant.id}/reject`,
                    {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                    }
                  );
                  if (!res.ok) {
                    const err = await res.json().catch(() => ({}));
                    throw new Error(err.detail || "Failed to reject applicant");
                  }

                  setSnackbar({
                    open: true,
                    message: "Applicant rejected successfully",
                    severity: "success",
                  });
                  setRejectDialogOpen(false);
                  setRejectApplicant(null);
                  fetchJobOrder();
                } catch (e) {
                  setRejectError(e.message || "Failed to reject applicant");
                } finally {
                  setRejecting(false);
                }
              }}
            >
              {rejecting ? <CircularProgress size={20} /> : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={aiModalOpen} onClose={() => setAiModalOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>
            Resume & Job JSON for {aiModalApplicant?.applicant_name || "Applicant"}
          </DialogTitle>
          <DialogContent dividers>
            {aiModalLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 180 }}>
                <CircularProgress />
              </Box>
            ) : aiModalError ? (
              <Typography color="error">{aiModalError}</Typography>
            ) : aiModalJson ? (
              <pre
                style={{
                  background: "#f5f5f5",
                  padding: 16,
                  borderRadius: 8,
                  fontSize: 14,
                  maxHeight: 400,
                  overflow: "auto",
                }}
              >
                {JSON.stringify(aiModalJson, null, 2)}
              </pre>
            ) : (
              <Typography color="text.secondary">No data.</Typography>
            )}

            {analyzeError && <Typography color="error" sx={{ mt: 2 }}>{analyzeError}</Typography>}
            {analyzeResult && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  AI Analysis Result
                </Typography>
                <pre
                  style={{
                    background: "#f0f7fa",
                    padding: 12,
                    borderRadius: 6,
                    fontSize: 14,
                    maxHeight: 300,
                    overflow: "auto",
                  }}
                >
                  {typeof analyzeResult === "string"
                    ? analyzeResult
                    : JSON.stringify(analyzeResult, null, 2)}
                </pre>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAiModalOpen(false)}>Close</Button>
            <Button onClick={handleSubmitAnalyze} variant="contained" disabled={analyzeLoading}>
              {analyzeLoading ? <CircularProgress size={20} /> : "Analyze Resume"}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

export default JobOrderDetail;